import React from "react";
import type { FunctionComponent } from "react";

interface StepIconProps {
  stepNumber: number | string;
  isComplete: boolean;
}

const StepIcon: FunctionComponent<StepIconProps> = ({ stepNumber, isComplete }) => {
  if (isComplete) {
    return (
      <span
        className="d-flex align-items-center justify-content-center rounded-circle text-white fw-bold"
        style={{ width: "2.5rem", height: "2.5rem", fontWeight: "bold", backgroundColor: "#01B163" }}>
        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M2 8.26L5.7135 12.1338L11.808 3.31403" stroke="white" strokeWidth="2.45753" strokeLinejoin="round" />
        </svg>
      </span>
    );
  }

  return (
    <span
      className="d-flex align-items-center justify-content-center rounded-circle text-white fw-bold"
      style={{ width: "2.5rem", height: "2.5rem", fontWeight: "bold", backgroundColor: "#052856" }}>
      {stepNumber}
    </span>
  );
};

export default StepIcon;
